import { useSeoEmptyPost } from '../../../../seo/UseSeoPage';

export const EmptyPost = () => {
  useSeoEmptyPost();
  return (
    <div className="bg-white shadow-lg mb-3 p-4 text-center">
      <p>Không có dữ liệu bài viết.</p>
    </div>
  );
};
